import { cn } from "@faire/prototype-playground/lib/utils";
import { usePlaygroundLocalization } from "@faire/prototype-playground/platform/localization";

export const LocalePanel: React.FC = () => {
  const { expandText, setExpandText } = usePlaygroundLocalization();

  return (
    <div className="w-64 rounded-xl border border-[#2a2a2a] bg-[#141414] shadow-[0_2px_8px_rgba(0,0,0,0.25)]">
      <div className="border-b border-[#2a2a2a] px-3 py-2">
        <span className="text-[11px] font-medium text-[#aaa]">
          Locale preview
        </span>
      </div>
      <div className="space-y-3 p-3">
        <p className="text-[12px] leading-relaxed text-[#bbb]">
          Preview how copy wrapped in{" "}
          <code className="text-[#ddd]">PlaygroundLocalMsg</code> may look in
          gibberish mode, using the same pseudo-locale algorithm as production
          localization testing.
        </p>
        <button
          type="button"
          onClick={() => setExpandText(!expandText)}
          className={cn(
            "flex w-full items-center justify-between rounded-lg px-2.5 py-2 text-left text-[12px] transition-colors",
            expandText
              ? "text-fs-text-primary-inverse bg-[#7B9EFF]/10 font-medium"
              : "text-[#ddd] hover:bg-[#1f1f1f]"
          )}
        >
          <span>Gibberish mode</span>
          <span
            className={cn(
              "inline-flex h-5 w-9 items-center rounded-full p-0.5 transition-colors",
              expandText ? "bg-[#7B9EFF]" : "bg-[#444]"
            )}
            aria-hidden
          >
            <span
              className={cn(
                "bg-fs-surface-primary h-4 w-4 rounded-full transition-transform",
                expandText ? "translate-x-4" : "translate-x-0"
              )}
            />
          </span>
        </button>
      </div>
    </div>
  );
};
